import Header from './Header';
import about from '../assets/about1.webp'
import bg from '../assets/bg.png'
import serv1 from '../assets/serv1.jpg';
import serv2 from '../assets/serv2.jpg';
import serv3 from '../assets/serv3.jpg';
import Footer from './Footer';


export default function About() {
  
  return (
    <div>
        {/* Header component */}
         <Header />
        {/* Main content section */}
       <section className="relative w-full bg-white py-[80px] lg:py-[100px]">
        <img
          src={about}
          alt="Hero Image"
          className="w-full h-[200px] md:h-[500px] object-cover"
        />
       <div className='w-full'>
        <div className='w-full h-screen flex mt-[15%] md:mt-1 flex-col justify-center items-center'>
        <div className="text-center max-w-4xl mx-auto px-6 lg:px-8">
          <h2 className="text-4xl font-maiandra tracking-tight mt-8 text-gray-900 sm:text-4xl">
            {/* Add heading text here */}OHS WORKS ltd
          </h2>
          <p className="mt-4 max-w-4xl text-lg font-myraid text-gray-600 mx-auto">
            OHS Works Ltd is a leading provider of comprehensive occupational health and safety (OHS) solutions in Rwanda, dedicated to creating safer and healthier work environments across multiple sectors. Guided by international best practices, we offer strategic consulting, high-quality safety gear, training, and a platform for advancing workplace safety through conferences.
          </p>
        </div>

        {/* Our Mission & Vision */}
        <div className="mt-34 md:mt-64 grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto px-6 lg:px-8">
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <h3 className="text-4xl font-maiandra text-gray-900">Our Mission</h3>
            <p className="mt-4 text-lg  text-gray-600">
              To deliver world-class OHS solutions through innovation, strategic partnerships, and a commitment to quality. We aim to foster safe, compliant, and sustainable workplaces for the future, across Rwanda and the region.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <h3 className="text-4xl font-maiandra text-gray-900">Our Vision</h3>
            <p className="mt-4 text-lg text-gray-600">
              To be Rwanda’s most trusted partner in occupational health and safety, empowering businesses to create safe, compliant, and efficient work environments.
            </p>
          </div>
        </div>
      </div>

          {/* Core Services */}
          <div
            className="bg-cover bg-center bg-fixed"
            style={{ backgroundImage: `url(${serv3})` }}
          >
    <div className="bg-black/50 mt-[0px] py-16 w-full h-full md:h-screen  flex items-center justify-center">
      <div className="container mx-auto">
      <h3 className="text-3xl lg:text-4xl font-maiandra text-white text-center mb-12">
        Our Core Services
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="bg-white/90 p-8 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300">
          <h4 className="text-xl font-maiandra text-gray-900 mb-4">OHS Consulting</h4>
          <p className="text-gray-700">
            We offer strategic consulting services including risk assessments, safety audits, OHS management systems, and regulatory compliance support, tailored to meet the unique needs of private and public sectors.
          </p>
        </div>

        <div className="bg-white/90 p-8 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300">
          <h4 className="text-xl font-maiandra text-gray-900 mb-4">OHS Conferences</h4>
          <p className="text-gray-700">
            Our annual conferences provide a platform for sharing innovations, best practices, and strategies to improve workplace safety, featuring industry experts and government officials.
          </p>
        </div>

        <div className="bg-white/90 p-8 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300">
          <h4 className="text-xl font-maiandra text-gray-900 mb-4">OHS Supplies</h4>
          <p className="text-gray-700">
            We supply a wide range of personal protective equipment (PPE) and industry-specific safety gear that meets international standards, ensuring the safety of the workforce.
          </p>
        </div>

        <div className="bg-white/90 p-8 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300">
          <h4 className="text-xl font-maiandra text-gray-900 mb-4">OHS Education</h4>
          <p className="text-gray-700">
            We offer comprehensive safety training and certification programs to build capacity and empower individuals and organizations in maintaining high safety standards.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

{/* Core Values */}
<div className="mt-16 mx-[10%] text-center h-[70%] pt-[5%]">
  <h3 className="text-3xl font-semibold text-gray-800 mb-8">Our Core Values</h3>
  <div className="grid grid-cols-1 lg:grid-cols-5 md:grid-cols-3 gap-8">
    
    <div
      style={{ backgroundImage: `url(${serv1})` }}
      className="bg-cover bg-center h-[200px] p-6 rounded-lg shadow-md relative"
    >
      <div className="absolute inset-0 bg-black bg-opacity-80 rounded-lg flex flex-col justify-center items-center p-4">
        <h4 className="text-2xl font-maiandra text-white">Safety First</h4>
        <p className="mt-4 text-white">
          Prioritizing the health and safety of workers in all our activities.
        </p>
      </div>
    </div>

    <div
      style={{ backgroundImage: `url(${serv1})` }}
      className="bg-cover bg-center h-[200px] p-6 rounded-lg shadow-md relative"
    >
      <div className="absolute inset-0 bg-black bg-opacity-80 rounded-lg flex flex-col justify-center items-center p-4">
        <h4 className="text-2xl font-maiandra text-white">Integrity</h4>
        <p className="mt-4 text-white">
          We uphold the highest standards of professionalism and ethical practices.
        </p>
      </div>
    </div>
    <div
      style={{ backgroundImage: `url(${serv2})` }}
      className="bg-cover bg-center h-[200px] p-6 rounded-lg shadow-md relative"
    >
      <div className="absolute inset-0 bg-black bg-opacity-80 rounded-lg flex flex-col justify-center items-center p-4">
        <h4 className="text-2xl font-maiandra text-white">Excellence</h4>
        <p className="mt-4 text-white">
          We strive for continuous improvement in our products and services.
        </p>
      </div>
    </div>

    <div
      style={{ backgroundImage: `url(${serv1})` }}
      className="bg-cover bg-center h-[200px] p-6 rounded-lg shadow-md relative"
    >
      <div className="absolute inset-0 bg-black bg-opacity-80 rounded-lg flex flex-col justify-center items-center p-4">
        <h4 className="text-2xl font-maiandra text-white">Collaboration</h4>
        <p className="mt-4  text-white">
          We work hand-in-hand with stakeholders to co-create impactful OHS solutions.
        </p>
      </div>
    </div>

    <div
      style={{ backgroundImage: `url(${serv2})` }}
      className="bg-cover bg-center h-[200px] p-6 rounded-lg shadow-md relative"
    >
      <div className="absolute inset-0 bg-black bg-opacity-80 rounded-lg flex flex-col justify-center items-center p-4">
        <h4 className="text-2xl font-maiandra text-white">Innovation</h4>
        <p className="mt-4 text-white">
          We embrace cutting-edge technologies and methods to enhance safety performance.
        </p>
      </div>
    </div>
  </div>

    
   
</div>

        </div>
      </section>
      <Footer />
    </div>
  );
}
